import React from "react";
import { Modal } from "../../../components/others/Modal";
import ImportAplicants from "./importAplicants";

type TProps = {
  show: boolean,
  urlTittle?: string,
  modalTitle?: string,
  onClose: Function
  refreshFunction?: Function

};

const ImportAplicantsModal = (
  { show,
    urlTittle,
    modalTitle,
    onClose,
    refreshFunction,
  }: TProps) => {
  const styles = "text-2xl text-red-500 font-bold";
  



  return (
    <Modal
      show={show}
      urlTittle={urlTittle}
      modalTitle={modalTitle}
      onClose={() => onClose && onClose}
      titleStyle={styles}
    >
      <ImportAplicants
        onClose={onClose}
        refreshFunction={refreshFunction}
      />

    </Modal>
  )
};

export default ImportAplicantsModal;
